<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
			>
				<!-- Assigned Date -->
				<div class="form-group row align-items-center">
					<label for="input_assigned_date" class="col-sm-3 mb-0">
						Date
					</label>
					<app-input
						id="input_assigned_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.assigned_date"
						placeholder="Assigned Date"
						:required="true"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "LogTableForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
	},
	data() {
		return {
			preloader: false,
			inputs: {},
			phone: "",
			modalId: this.formId,
			modalTitle: this.$t("add"),
			interested_in_list: [
				{ id: "interested_in_1", value: "Interested In 1" },
				{ id: "interested_in_2", value: "Interested In 2" },
				{ id: "interested_in_3", value: "Interested In 3" },
			],
			nearest_clc_list: [
				{ id: "nearest_clc_1", value: "Nearest CLC 1" },
				{ id: "nearest_clc_2", value: "Nearest CLC 2" },
				{ id: "nearest_clc_3", value: "Nearest CLC 3" },
			],
			sub_status_list: [
				{ id: "active", value: "Active" },
				{ id: "inactive", value: "Inactive" },
				{ id: "invited", value: "Invited" },
			],
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.preloader = false;
		},
	},
};
</script>
